import PropTypes from 'prop-types';

import TransposePlugin from '../plugins/TransposePlugin';

import { useGlobalContext } from '../../../../context/GlobalContext';

const ViewSongPluginsPerSong = ({ song, songIndex, onKeyChange, onManualTranspose }) => {
  const { isScrolling } = useGlobalContext();
  const target = `song-section-${songIndex}`;

  return (
    <div className={`ViewSongPlugins horizontal-menu ${isScrolling ? 'disabled' : ''}`}>
      <TransposePlugin
        target={target}
        disabled={isScrolling}
        songId={song._id}
        songIndex={songIndex}
        onKeyChange={onKeyChange}
        onManualTranspose={onManualTranspose}
      />
    </div>
  );
};

ViewSongPluginsPerSong.propTypes = {
  song: PropTypes.object.isRequired,
  songIndex: PropTypes.number.isRequired,
  onKeyChange: PropTypes.func,
  onManualTranspose: PropTypes.func,
};

export default ViewSongPluginsPerSong;
